import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../routes/PathLink'
import { Table } from "../components/ui/table";
//import { Table } from "antd";
import { amount_format } from "../components/config/Common";
const IndicesTable = (props) => {	
    const {data, pageSize, isLoading, paginatorInfo, pageType} = props
    //console.log('data props===',data)

    const skeleton = Array.from({ length: pageSize }, (_, i) => ({
    id: `sk-${i}`,
    _isSkeleton: true
    }));

    const columns = [
        {
          title: 'Sr.No.',
          dataIndex: 'srno',
          key: 'id',
          align: 'left',
          width: 50,
          render: (text, record, index) => {
            return index+1
            /* if (record._isHeader) {
                return "Sr.No.";
            }
    
            // Count only non-header rows
            const realIndex = modifiedData
                .slice(0, index)
                .filter(r => !r._isHeader)
                .length;
    
            return realIndex + 1; */
            
        },
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          align: 'left',
          width: 200,
          render:(name,record) =>{
              let path = `${record.id}`;
              if(pageType == '/sectors'){
                path = `${record.slug}`
              }

             return (<div
              className="overflow-hidden truncate whitespace-nowrap text-wrap" >
               {record?.name && record?.name != '' ?
                (<Link className="text-accent" to={`${process.env.REACT_APP_URL}${pageType}/${path}`}><span className="text-sm">{record?.name}</span></Link>)
                :(null)
              }          
            </div>)
            }
        },
        {
          title: <div className='cursor-pointer'>No. of Companies</div>,
          dataIndex: 'company_count',
          key: 'company_count',
          align: 'left',
          width: 100,
        },
        /* {
          title: <div className='cursor-pointer' title='Price to Earnings Ratio'>P/E</div>,
          dataIndex: 'pe',
          key: 'pe',
          align: 'left',
          width: 100,
        }, */
        {
          title: <div className='cursor-pointer' title='Market Capitalization'>Total Market Cap <span className="text-xs text-gray-500">Rs.Cr.</span></div>,
          dataIndex: 'sum_market_cap',
          key: 'sum_market_cap',
          align: 'left',
          width: 100,
          render:(name,record) =>(
            <>{data && <div>{amount_format(record?.sum_market_cap)}</div>}</>
          )
        },
        /* {
          title: <div className='cursor-pointer' title='Dividend Yield'>Div Yld <span className="text-xs text-gray-500">%</span></div>,
          dataIndex: 'divyld',
          key: 'divyld',
          align: 'left',
          width: 100,
        },
        {
          title: <div className='cursor-pointer' title='Net Profit Latest Quarter'>NP Qtr <span className="text-xs text-gray-500">Rs.Cr.</span></div>,
          dataIndex: 'netprofitqtr',
          key: 'netprofitqtr',
          align: 'left',
          width: 100,
        },
        {
          title: <div className='cursor-pointer' title='Return on Capital Employed'>ROCE <span className="text-xs text-gray-500">%</span></div>,
          dataIndex: 'roce',
          key: 'roce',
          align: 'left',
          width: 100,
        }, */
      
    ];

    const modifiedData = insertHeaderEvery(data || [], columns, 10);

function insertHeaderEvery(result, columns, interval = 20) {
  const updated = [];

  result.forEach((row, index) => {
    // Insert header row before row number (multiple of interval)
    if (index % interval === 0 && index !== 0) {
      updated.push({ ...columns.reduce((acc, col) => {
        acc[col.dataIndex] = col.title;
        return acc;
      }, {}), _isHeader: true });
    }
    updated.push(row);
  });
  
  return updated;
}

    return (
        <>
            {paginatorInfo &&
            <div className="mt-5 text-sm text-gray-500">
                {paginatorInfo?.total} results found.
            </div>
            }
            <div className="my-6 overflow-hidden rounded shadow">
            <Table            
                columns={columns}
                rowKey="id"
                data={isLoading ? skeleton : data}
                scroll={{ x: 900 }}
                
                rowClassName={(record, index) => {
                    if (record._isSkeleton) {
                        // Animate only alternate skeleton rows (even rows)
                        return index % 2 === 0
                        ? "skeleton-row pulse-row"
                        : "skeleton-row-odd";
                    }

                    if (record._isHeader) return "repeat-header";

                    return "";
                }}
            />
            </div>
        </>    
    )
}

export default IndicesTable;